import { useState } from 'react';

type UseAuthRedirectArgs = {
    isLoading: boolean;
    isAuthenticated: boolean | undefined;
    login: () => void;
    altlogin: () => void;
    onAuthenticatedNavigate: () => void;
};

// Owns the "redirect to login/altlogin, or re-arm the session timers on
// navigation" logic that used to be a deeply-nested if/else chain in App.
export const useAuthRedirect = ({
    isLoading,
    isAuthenticated,
    login,
    altlogin,
    onAuthenticatedNavigate,
}: UseAuthRedirectArgs) => {
    const [sessionLocation, setSessionLocation] = useState('');

    const pathname = window.location.pathname.toLowerCase();
    const isNotLogout = pathname !== '/logout' && pathname !== '/loggedout';

    if (isLoading !== true && isAuthenticated !== true) {
        if (pathname === '/altlogin') {
            altlogin();
        } else if (isNotLogout) {
            login();
        }
        return;
    }

    if (isAuthenticated === true && sessionLocation !== window.location.pathname) {
        setSessionLocation(window.location.pathname);
        if (isNotLogout) {
            onAuthenticatedNavigate();
        }
    }
};
